import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { ResultsMenuStoreContext } from "@state/context/results";

export default observer(function ResultsSearchPhraseInfo() {
	const { t } = useTranslation();
	const { resultsDataStore } = useContext(ResultsMenuStoreContext);

	if (!resultsDataStore.searchPhrase) {
		return null;
	}

	return (
		<div className="card--primary__header card--primary__header--borderless u-padd--top--big u-padd--bottom--reset">
			<div className="card--primary__title">
				<i className="u-icon u-icon--sml u-icon--search u-mar--right--tny" />
				<span>
					{t("RESULTS.RESULT_CONTENT.SEARCH.SEARCH_RESULT_FOR")}
				</span>
				<span className="u-mar--left--xtny u-type--style--italic">
					{resultsDataStore.searchPhrase}
				</span>
			</div>

			<div className="card--primary__actions">
				<button
					className="card--primary__actions__btn btn btn--square btn--square--xsml btn--ghost--danger btn--icon"
					type="button"
					onClick={resultsDataStore.clearSearchPhrase}
				>
					<i className="u-icon u-icon--tny u-icon--close" />
				</button>
			</div>
		</div>
	);
});
